import React, { createContext, useContext, useState } from 'react';

const NavMenuContext = createContext();

export const NavMenuProvider = ({ children }) => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [menuStack, setMenuStack] = useState(['main']);

  const openMenu = (type, stack = ['main']) => {
    // The fullscreen menu lives inside Nav, at the top of the document.
    // Jump there first so it isn't opened off-screen while scroll is locked.
    // "instant" (not "auto") is required to bypass the global `scroll-behavior: smooth`.
    window.scrollTo({ top: 0, behavior: 'instant' });
    setMenuStack(stack);
    setActiveMenu(type);
  };

  const closeMenu = () => {
    setActiveMenu(null);
    setMenuStack(['main']);
  };

  return (
    <NavMenuContext.Provider
      value={{
        activeMenu,
        setActiveMenu,
        menuStack,
        openMenu,
        closeMenu,
      }}
    >
      {children}
    </NavMenuContext.Provider>
  );
};

export const useNavMenu = () => useContext(NavMenuContext);
